import http from '@/requests/http'

class CallerId {
  static all (params) {
    return http.post('caller-id/configuration/index', params)
  }
  static async editUsers (params) {
    return http.post('caller-id/configuration/users', params)
  }
  static async updateUsers (params) {
    return http.post('caller-id/configuration/update-users', params)
  }
  static displayAll () {
    return http.post('caller-id/outbound-popup/index')
  }
}

export default CallerId
